module.exports = __webpack_public_path__ + "img/Pham2.d10d5aa0.jpg";